import JerryCanIcon from '~/images/icons/jerry_can_icon.png';
import {
  amountWithAbbreviation,
  amountWithPrecisionAsRequiredAndComma,
} from '~/javascripts/utils/numberFormatter';
import { observer } from 'mobx-react';

const Header = observer(({ lastUpdatedDate, siteConstantsFromContentful }) => (
  <div className='theme-design-system-v1 map-header-container flex flex-col xl-flex-row justify-between'>
    <div className='flex flex-col xl-flex-row items-center justify-center p-8 text-center xl-text-left'>
      <img height='55px' src={JerryCanIcon} width='55px' />
      <div className='flex flex-col pl-0 xl-pl-4'>
        <h1 className='heading-xl xl-heading-l text-cw-white pt-4 pb-2 xl-p-0 text-center'>
          charity: water
        </h1>
        <p className='body-xs text-cw-white'>Last updated: {lastUpdatedDate}</p>
      </div>
    </div>
    <div className='stat-section flex flex-row border border-grey-70 border-l-0 border-b-0 border-r-0 xl-border-t-0 py-0 justify-between xl-justify-center'>
      <div className='flex flex-col items-center justify-center w-1/3 xl-w-auto p-0 xl-p-8 text-center xl-border border-grey-70 xl-border-t-0 xl-border-b-0 xl-border-r-0'>
        <h1 className='heading-l text-cw-white'>
          <span className='show-for-mobile-only uppercase'>
            {amountWithAbbreviation(
              siteConstantsFromContentful.people_served_number
            )}
          </span>
          <span className='show-for-medium-up'>
            {amountWithPrecisionAsRequiredAndComma(
              siteConstantsFromContentful.people_served_number
            )}
          </span>
        </h1>
        <p className='body-2xs text-cw-white show-for-mobile-only'>
          people served
        </p>
        <p className='body-xs text-cw-white show-for-medium-up'>
          people served
        </p>
      </div>
      <div className='flex flex-col items-center justify-center w-1/3 xl-w-auto py-7 xl-p-8 text-center border border-grey-70 border-t-0 border-b-0 border-r-0'>
        <h1 className='heading-l text-cw-white'>
          <span className='show-for-mobile-only uppercase'>
            {amountWithAbbreviation(
              siteConstantsFromContentful.funded_water_projects
            )}
          </span>
          <span className='show-for-medium-up'>
            {amountWithPrecisionAsRequiredAndComma(
              siteConstantsFromContentful.funded_water_projects
            )}
          </span>
        </h1>
        <p className='body-2xs text-cw-white show-for-mobile-only'>
          water projects
        </p>
        <p className='body-xs text-cw-white show-for-medium-up'>
          water projects
        </p>
      </div>
      <div className='flex flex-col items-center justify-center w-1/3 xl-w-auto p-0 xl-p-8 text-center border border-grey-70 border-t-0 border-b-0 border-r-0'>
        <h1 className='heading-l text-cw-white'>
          {amountWithPrecisionAsRequiredAndComma(
            siteConstantsFromContentful.countries_worked_in
          )}
        </h1>
        <p className='body-2xs text-cw-white show-for-mobile-only'>countries</p>
        <p className='body-xs text-cw-white show-for-medium-up'>countries</p>
      </div>
    </div>
  </div>
));
export default Header;
